import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, UrlTree } from '@angular/router';
import { VueUserSessionService } from '@vue/vueframework';

/**
 * This checks if the user is logged in, and if not
 * will send them to the authenticate endpoint with
 * a redirect query params appended to the url.
 */
@Injectable({ providedIn: 'root' })
export class VerifyAuthWithRedirect {
  public constructor(
    private userSession: VueUserSessionService,
    private router: Router) { }

  public canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    if (this.userSession.isUserAuthenticated()) {
      return true;
    }

    const redirect = route.url.join('/');
    return this.router.createUrlTree([ '/authenticate' ], { queryParams: {
      redirect
    } });
  }
}
